module.exports = __webpack_public_path__ + "d7a0edd9aa3455d3c4d199df7d73328a.pdf";